import omit from 'lodash/omit'

// In future phase of work: set these values based on api
// (values set in admin)
const DEFAULT_APPRAISAL_COST = 0
const DEFAULT_TAX_PERCENT = 13
const DEFAULT_CLIENT_BUDGET = 0

const initialState = {
  diamonds: {},
  jewelry: {},
  nextJewelryId: 1,
  nextDiamondId: 1,
  taxPercent: DEFAULT_TAX_PERCENT,
  clientBudgetIsAfterTax: false,
  clientNotes: '',
  salesNotes: '',
  customDepositAmount: null,
  diamondDepositRate: 0,
  jewelryDepositRate: 0,
  clientBudget: DEFAULT_CLIENT_BUDGET
}

export default function cart (state = initialState, action) {
  switch (action.type) {
    case 'ADD_DIAMONDS_TO_CART':
      const diamondsToAdd = action.value.reduce((acc, diamond) => {
        acc[state.nextDiamondId] = {
          data: diamond,
          checkout: false
        }
        state.nextDiamondId += 1
        return acc
      }, {})
      return {
        ...state,
        diamonds: Object.assign({}, state.diamonds, diamondsToAdd)
      }
    case 'REMOVE_DIAMOND_FROM_CART':
      return {
        ...state,
        diamonds: omit(state.diamonds, action.value)
      }
    case 'ADD_JEWELRY_TO_CART':
      return {
        ...state,
        jewelry: {
          ...state.jewelry,
          [action.value.id]: {
            data: action.value.data,
            filters: action.value.filters,
            appraisalCostInCAD: DEFAULT_APPRAISAL_COST,
            appraisalCostInUSD: DEFAULT_APPRAISAL_COST,
            additionalNotes: action.value.filters.additional_notes ? action.value.filters.additional_notes : null,
            description: action.value.description,
            descriptionEditing: false,
            checkout: false
          }
        },
        nextJewelryId: state.nextJewelryId + 1
      }
    case 'UPDATE_JEWELRY_IN_CART':
      return {
        ...state,
        jewelry: {
          ...state.jewelry,
          [action.value.id]: {
            data: action.value.data,
            filters: action.value.filters
          }
        }
      }
    case 'REMOVE_JEWELRY_FROM_CART':
      return {
        ...state,
        jewelry: omit(state.jewelry, action.value)
      }
    case 'TOGGLE_DIAMOND_CHECKOUT':
      return {
        ...state,
        customDepositAmount: null,
        diamonds: {
          ...state.diamonds,
          [action.value]: {
            ...state.diamonds[action.value],
            checkout: !state.diamonds[action.value].checkout
          }
        }
      }
    case 'TOGGLE_JEWELRY_CHECKOUT':
      return {
        ...state,
        customDepositAmount: null,
        jewelry: {
          ...state.jewelry,
          [action.value]: {
            ...state.jewelry[action.value],
            checkout: !state.jewelry[action.value].checkout
          }
        }
      }
    case 'JEWELRY_SET_DESCRIPTION_EDITING':
      return {
        ...state,
        jewelry: {
          ...state.jewelry,
          [action.value.id]: {
            ...state.jewelry[action.value.id],
            descriptionEditing: action.value.descriptionEditing,
          }
        }
      }
    case 'JEWELRY_UPDATE_DESCRIPTION':
      const jewelry = state.jewelry[action.value.id]
      if (jewelry.data.jewellery_type === 'stock_item') {
        jewelry.data = {...jewelry.data, item_description: action.value.description}
        jewelry.filters = {...jewelry.filters, item_description: action.value.description}
      }
      return {
        ...state,
        jewelry: {
          ...state.jewelry,
          [action.value.id]: {
            ...jewelry,
            description: action.value.description
          }
        }
      }
    case 'CART_FIELD_CHANGED':
      return {
        ...state,
        [action.value.field]: action.value.value
      }
    case 'APPRAISAL_COST_CHANGED':
      return {
        ...state,
        jewelry: {
          ...state.jewelry,
          [action.value.jewelryId]: {
            ...state.jewelry[action.value.jewelryId],
            appraisalCostInUSD: action.value.appraisalCostInUSD || 0,
            appraisalCostInCAD: action.value.appraisalCostInCAD || 0
          }
        }
      }
    case 'SET_DEPOSIT_RATES':
      return {
        ...state,
        diamondDepositRate: action.value.diamondDepositRate,
        jewelryDepositRate: action.value.jewelryDepositRate
      }
    case 'CLEAR_CUSTOM_DEPOSIT':
      return {
        ...state,
        customDepositAmount: null
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/cart.js